import format from "date-fns/format";
import { DATE_TIME_FORMAT } from "@/Constants";

function removeTimeZonePart(dateString: string): string {
  let finalDate = dateString;

  if (dateString.split("+").length > 1) {
    const b = dateString.split("+");
    finalDate = b[0];
  } else {
    const b = dateString.split("-");
    if (b.length > 3) {
      b.pop();
      finalDate = b.join("-");
    }
  }
  return finalDate;
}

function formatToSiteLocalDateTime(dateString: string, formatString?: string) {
  if (dateString === undefined || dateString === null || dateString === "") {
    return "";
  }
  if (!formatString) {
    formatString = DATE_TIME_FORMAT;
  }
  const newDateString = removeTimeZonePart(dateString);
  const date = new Date(newDateString);
  return format(date, formatString);
}

export default formatToSiteLocalDateTime;
